import React from 'react';
import { Button, Tooltip} from 'antd';
import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    align: 'center',
                    sorter: true
                },
                {
                    title: 'Compra SUNAT',
                    dataIndex: 'compraStr',
                    key: 'compraStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Venta SUNAT',
                    dataIndex: 'ventaStr',
                    key: 'ventaStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Compra COMERCIAL',
                    dataIndex: 'compraComercialStr',
                    key: 'compraComercialStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Venta COMERCIAL',
                    dataIndex: 'ventaComercialStr',
                    key: 'ventaComercialStr',
                    align: 'right',
                    sorter: true
                }
            ]}
        />
    );
}